import React from "react";

import { ExpressionTypes, Props } from "./types";
import { replaceContent, styleMentions } from "./expressionMatcher";

function MarkDownContent({ content, resources, replacements }: Props) {
  return (
    <React.Fragment>
      {replaceContent(
        content,
        replacements,
        resources.map(({ name }) => name),
      )}
    </React.Fragment>
  );
}

MarkDownContent.ExpressionTypes = ExpressionTypes;
MarkDownContent.replaceContent = replaceContent;
MarkDownContent.styleMentions = styleMentions;

export { MarkDownContent };
